import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { formatAmount } from '../../utils/formatAmount';
import useReport from './useReport';
import { formatDate } from '../../utils/dateUtils';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';


const ProfitSummaryReport = () => {

  const {reportData, getProfitSummaryReport} = useReport() 
  const [monthReportData, setMonthReportData] = useState([])


  function formatMonth(dateString) {
    const date = new Date(dateString);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = date.getFullYear().toString().substring(2); // Last two digits of the year
    const month = monthNames[date.getMonth()];
    return `${month}-${year}`;
  } 

  const groupAndSummarize = (data) => {
    const groupedData = {};

    data.forEach(item => {
      const monthYear = formatMonth(item.shipDate);
      if (!groupedData[monthYear]) {
        groupedData[monthYear] = {
          month: monthYear,
          totalExchange: 0,
          totalAmount: 0,
          totalAmountPaid: 0,
          thaiShippingPaid: 0,
          thaiShippingTotal: 0,
          totalExpense: 0,
          totalJpDeliveryPaid: 0,
          totalJpDevliery:0,
          totalWeightPrice:0,
          totalWeightPricePaid:0,
        };
      }

      // Summarize data
      groupedData[monthYear].totalExchange += item.totalExchange;
      groupedData[monthYear].totalAmount += item.totalAmount;
      groupedData[monthYear].totalAmountPaid += item.totalAmountPaid;
      groupedData[monthYear].thaiShippingPaid += item.thaiShippingPaid;
      groupedData[monthYear].thaiShippingTotal += item.thaiShippingTotal;
      groupedData[monthYear].totalExpense += item.totalExpense;
      groupedData[monthYear].totalJpDeliveryPaid += item.totalJpDeliveryPaid;
      groupedData[monthYear].totalJpDevliery += item.totalJpDevliery;
      groupedData[monthYear].totalWeightPrice += item.totalWeightPrice;
      groupedData[monthYear].totalWeightPricePaid += item.totalWeightPricePaid;
      // ... summarize other fields
    });
    const dataArray = Object.values(groupedData);
    setMonthReportData(dataArray);
  }

  // Function to format the date in reportData for comparison
  const getMonthYear = (dateString) => {
    const date = new Date(dateString);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = date.getFullYear().toString().substring(2); // Last two digits of the year
    const month = monthNames[date.getMonth()];
    return `${month}-${year}`;
  };


  useEffect(() => {
    console.log(monthReportData)
  },[monthReportData])

  useEffect(() => {
    reportData && groupAndSummarize(reportData)
  },[reportData])

  useEffect(() => {
    getProfitSummaryReport()
  },[])

  function Row({monthData, reportData}) {
    const [open, setOpen] = React.useState(false);

    // Function to filter the report data based on the month
    const filteredData = reportData.filter(item => 
      getMonthYear(item.shipDate) === monthData.month
    );

    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {monthData?.month}
          </TableCell>
          <TableCell>{`${formatAmount(monthData.totalAmountPaid)} (${formatAmount(monthData.totalAmount && monthData.totalAmountPaid*100/monthData.totalAmount)}%)`}</TableCell>
          <TableCell>{`${formatAmount(monthData.totalJpDeliveryPaid)} (${formatAmount(monthData.totalJpDevliery && monthData.totalJpDeliveryPaid*100/monthData.totalJpDevliery)}%)`}</TableCell>
          <TableCell>{`${formatAmount(monthData.totalWeightPricePaid)} (${formatAmount(monthData.totalWeightPrice && monthData.totalWeightPricePaid*100/monthData.totalWeightPrice)}%)`}</TableCell>
          <TableCell>{`${formatAmount(monthData.thaiShippingPaid)} (${formatAmount(monthData.thaiShippingTotal && monthData.thaiShippingPaid*100/monthData.thaiShippingTotal)}%)`}</TableCell>
          <TableCell>{formatAmount(monthData.totalExchange)}</TableCell>
          <TableCell>{formatAmount(monthData.totalExpense)}</TableCell>
          <TableCell>{formatAmount(monthData.totalAmountPaid + monthData.totalJpDeliveryPaid + monthData.totalWeightPricePaid + monthData.thaiShippingPaid - monthData.totalExchange - monthData.totalExpense)}</TableCell>
          <TableCell>{formatAmount(monthData.totalAmount + monthData.totalJpDevliery + monthData.totalWeightPrice + monthData.thaiShippingTotal - (monthData.totalAmountPaid + monthData.totalJpDeliveryPaid + monthData.totalWeightPricePaid + monthData.thaiShippingPaid))}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={18}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableBody>
                    <TableRow>
                      <TableCell style={{fontWeight : 'bold'}} >รอบเรือ</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >รายได้ค่าสินค้า</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >รายได้ค่าส่งญี่ปุ่น</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >รายได้ค่าน้ำหนัก</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >รายได้ค่าส่งไทย</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ต้นทุน แลกเงิน</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >ค่าใช้จ่ายทั้งหมด</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >Current Profit</TableCell>
                      <TableCell style={{fontWeight : 'bold'}} >รอชำระ</TableCell>
                    </TableRow>
                  {filteredData && filteredData.map((row) => {
                    return (
                      <TableRow key={row.shipDate}>
                        <TableCell>{formatDate(row.shipDate)}</TableCell>
                        <TableCell>{`${formatAmount(row.totalAmountPaid)} (${formatAmount(row.totalAmount && row.totalAmountPaid*100/row.totalAmount)}%)`}</TableCell>
                        <TableCell>{`${formatAmount(row.totalJpDeliveryPaid)} (${formatAmount(row.totalJpDevliery && row.totalJpDeliveryPaid*100/row.totalJpDevliery)}%)`}</TableCell>
                        <TableCell>{`${formatAmount(row.totalWeightPricePaid)} (${formatAmount(row.totalWeightPrice && row.totalWeightPricePaid*100/row.totalWeightPrice)}%)`}</TableCell>
                        <TableCell>{`${formatAmount(row.thaiShippingPaid)} (${formatAmount(row.thaiShippingTotal && row.thaiShippingPaid*100/row.thaiShippingTotal)}%)`}</TableCell>
                        <TableCell>{formatAmount(row.totalExchange)}</TableCell>
                        <TableCell>{formatAmount(row.totalExpense)}</TableCell>
                        <TableCell>{formatAmount(row.totalAmountPaid + row.totalJpDeliveryPaid + row.totalWeightPricePaid + row.thaiShippingPaid - row.totalExchange - row.totalExpense)}</TableCell>
                        <TableCell>{formatAmount(row.totalAmount + row.totalJpDevliery + row.totalWeightPrice + row.thaiShippingTotal - (row.totalAmountPaid + row.totalJpDeliveryPaid + row.totalWeightPricePaid + row.thaiShippingPaid))}</TableCell>
                      </TableRow>
                    );
                  })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  
  return (
    <TableContainer component={Paper}>
      <Table aria-label="table">
        <TableHead>
          <TableRow className='bg-indigo-600'>
            <TableCell/>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >เดือน</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >รายได้ค่าสินค้า</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >รายได้ค่าส่งญี่ปุ่น</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >รายได้ค่าน้ำหนัก</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >รายได้ค่าส่งไทย</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ต้นทุน แลกเงิน</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >ค่าใช้จ่ายทั้งหมด</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >Current Profit</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >รอชำระ</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {monthReportData && monthReportData.map((monthData) => (
            <Row 
              key={monthData.month} 
              monthData={monthData}
              reportData={reportData} 
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ProfitSummaryReport